import React from 'react';

const Bard_Resume = () => {
  return (
    <div>
      <h1>Bard_Resume</h1>
      <p>This is the Bard_Resume component.</p>
    </div>
  );
};

export default Bard_Resume;
